import script from "./recordVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./recordVideo.vue?vue&type=script&setup=true&lang=js"

import "./recordVideo.vue?vue&type=style&index=0&id=6f915c3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f915c3a"]])

export default __exports__